module.exports = __webpack_public_path__ + "static/menasha-logo-d202eeae3ac96d4cf483036d5c06e728.png";